import React from 'react'
import { IconSparkles } from '@tabler/icons-react'

export const AiSparkles = () => (
  <div className="flex-align-center">
    <IconSparkles className="status-magical icon-svg ml" fill="var(--color-magical)" />
    <strong>AI</strong>
  </div>
)
